import { baseApi } from "../../../app/api";
import {
  ContactFormPayload,
  ContactFormResponse,
} from "../types/contactApiTypes";

const CUSTOM_REST_API_BASE =
  window.commonVariables?.customRestApiBase || "/wp-json/ecommerce-app/v1";

export const contactApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    submitContactForm: builder.mutation<
      ContactFormResponse,
      ContactFormPayload
    >({
      query: (payload) => {
        // Transform camelCase UI data to snake_case Backend data
        const apiBody = {
          ...payload,
          form_load_timestamp: payload.formLoadTimestamp,
        };

        // Remove the camelCase key to keep the payload clean
        delete (apiBody as any).formLoadTimestamp;

        return {
          url: `${CUSTOM_REST_API_BASE}/forms/contact`,
          method: "POST",
          body: apiBody,
        };
      },
    }),
  }),
});

export const { useSubmitContactFormMutation } = contactApi;
